export { default as YotpoRatingWidget } from './YotpoRatingWidget'



// WEBPACK FOOTER //
// ./src/components/yotpoRatingWidget/index.js